/**
 * 产品文案Tab组件（简化版）
 * 包含：文案基础信息、Listing文案
 */

import React from 'react';
import { Card, Form, Row, Col, Input, Divider, FormInstance } from 'antd';

const { TextArea } = Input;

interface CopywritingTabProps {
    form: FormInstance;
}

export const CopywritingTab: React.FC<CopywritingTabProps> = ({ form }) => {
    return (
        <Card bordered={false}>
            <Form form={form} layout="vertical">
                <Divider orientation="left">文案基础</Divider>
                <Form.Item name="product_name" label="产品全称">
                    <Input placeholder="产品的完整商业名称" />
                </Form.Item>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item name="desired_feeling" label="期望感受">
                            <Input placeholder="例如：专业、可靠、高端..." />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="brand_story" label="品牌故事">
                            <TextArea rows={2} placeholder="品牌愿景..." />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="lifestyle_scene" label="生活场景">
                    <TextArea rows={3} placeholder="产品使用的具体场景描述..." />
                </Form.Item>

                <Divider orientation="left">Listing文案</Divider>
                <Form.Item name="listing_title" label="Listing标题">
                    <TextArea rows={2} placeholder="产品标题..." />
                </Form.Item>
                <Form.Item name="bullet_points" label="五点描述">
                    <TextArea rows={6} placeholder="每行一个卖点..." />
                </Form.Item>
                <Form.Item name="product_description" label="产品描述">
                    <TextArea rows={6} placeholder="详细产品描述..." />
                </Form.Item>
            </Form>
        </Card>
    );
};

export default CopywritingTab;
